const Strings = {
  NEW_POST: 'Nytt inlägg',
  NEW_NEWS_INFO:
    'Informera era boende om vad som händer i er förening genom att skapa ett nytt inlägg. När du skickar inlägget får alla boende en push notifikation i sina telefoner och kan ta del av informationen.',
  NO: 'Nej',
  YES: 'Ja',
  SEND: 'Skicka',
  EMPTY_POST_HEADER: 'Tomt inlägg',
  EMPTY_POST:
    'Det går inte att skicka ett tomt inlägg. Skriv ett inlägg och försök igen.',
  OK: 'Okej',
  REQUEST_SEND_POST_HEADER: 'Skicka inlägg',
  REQUEST_SEND_POST: 'Är du säker på att du vill skicka inlägget?',
  ALL_POSTS: 'Alla inlägg',
  COMING_SOON: 'Kommer snart',
  POST_CREATED_HEADER: 'Inlägget har skapats',
  POST_CREATED:
    'Inlägget har skapats. En push notifikation har skickats ut till alla medlemmar.',
  POST_REMOVED: 'Inlägget har tagits bort'
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/pages/NewsFeed/strings.js